// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"72460b5c","348":"1ebaf78e","558":"0a59d029","571":"f85d3dec"}[chunkId] + ".chunk.js";
};